//components
import {
  Team,
  TeamContainer,
  Title,
  Description,
  TeamGroup,
  Section,
} from './TeamSection.styles';

export const TeamSection = () => (
  <Section>
    <TeamContainer>
      <TeamGroup>
        <Team>
          <Title>People and Experiences</Title>
          <Description>
            We ensure our people come first. Training and development begin day
            one so that our teams have the tools they need to achieve amazing
            results.
          </Description>
        </Team>
        <Team>
          <Title>Engineering</Title>
          <Description>
            We are the nerds. By leveraging the power of automation and
            approaching engineering as a craft, we deliver high quality software
            to move more with less.
          </Description>
        </Team>
        <Team>
          <Title>Product & Design</Title>
          <Description>
            We create products our customers love. Using data and
            sound-research, our cross-functional teams crunch the complexity of
            logistics with users in mind.
          </Description>
        </Team>
        <Team>
          <Title>Sales & Marketing</Title>
          <Description>
            We build customer relationships and brand affinity face-to-face and
            digitally. Our clients come for the best-in-class products, but stay
            for the brand.
          </Description>
        </Team>
      </TeamGroup>
      <TeamGroup>
        <Team>
          <Title>Operations</Title>
          <Description>
            We put in the work to make sure freight gets from Point A to Point
            B. Working alongside our technology, we are setting a new benchmark
            for logistics service.
          </Description>
        </Team>
        <Team>
          <Title>Pricing Ops</Title>
          <Description>
            We price the present and future of freight. Using industry expertise
            and market trends, we provide unrivaled value to our shipper and
            carrier partners.
          </Description>
        </Team>
        <Team>
          <Title>Finance & BI</Title>
          <Description>
            We are driven by numbers. By providing data and intelligence, our
            analysts help make the most well-informed financial decisions for
            the business.
          </Description>
        </Team>
        <Team>
          <Title>Admin & Legal</Title>
          <Description>
            We anticipate and take on bumps in the road. We support our people,
            operations, and technology so they can continuously exceed
            expectations.
          </Description>
        </Team>
      </TeamGroup>
    </TeamContainer>
  </Section>
);
